import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, exhaustMap, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { ParameterType, ShopsService, ShopsView } from '../../_generated';
import { RequestStatusAction } from '../actionstypes/request-status/request-status.actiontype';
import * as ShopIdAction from '../actionstypes/selected-id/shop-id.actiontype';
import { ShopsRequestStatusAction } from '../actionstypes/shops/shops-request-status.actiontype';
import * as ShopsAction from '../actionstypes/shops/shops.actiontype';
import { DataEntryStore } from '../reducers/data-entry.reducer';
import { getDataType } from '../selectors/data-type.selector';
@Injectable()
export class ShopsEffect {
  private readonly actions$ = inject(Actions);
  private readonly shopsService = inject(ShopsService);
  private readonly store = inject<Store<DataEntryStore>>(Store);

  loadShops$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ShopsAction.ShopsAction.Load),
      withLatestFrom(this.store.select(getDataType)),

      exhaustMap(([, dataType]: [ShopsAction.Load, ParameterType]) =>
        this.shopsService.shopsControllerFindAll(dataType).pipe(
          switchMap((shops: ShopsView[]) => [new ShopIdAction.Sync(shops.map((shop) => shop.id)), new ShopsAction.Get(shops)]),
          catchError((error) => of(new RequestStatusAction(ShopsRequestStatusAction.Error, error as Error))),
        ),
      ),
    ),
  );

  successRequestShops$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ShopsAction.ShopsAction.Get),
      mergeMap(() => of(new RequestStatusAction(ShopsRequestStatusAction.Success))),
    ),
  );
}
